export enum UserAction {
  READ = 'READ',
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export enum Resource {
  USERS = 'users',
  ROLES = 'roles',
  PERMISSIONS = 'permissions',
  FORNITORI = 'fornitori',
  GESTORI = 'gestori',
  IMPIANTI = 'impianti',
  ORDINI = 'ordini',
  PLATSSZERO = 'platss-zero',
  CARICHI = 'carichi',
  SCARICHI = 'scarichi',
  REPORTIMPIANTI = 'report-impianti',
  PREZZIPOMPA = 'prezzi-pompa',
  ZONE = 'zone',
  INCASSI = 'incassi',
}
